import React, { useState, useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import Layout from "../../../Layout/Layout";
import { InputField } from "../../../Components/formElements/InputField";
// import HomeIntorVideo from "../../../Components/Modal/supplier_app/HomeIntro/HomeIntorVideo";
import HomeCategorieDetails from "../../../Components/Modal/supplier_app/HomeIntro/HomeCategorieDetails";
import LoaderSmall from "../../../Components/LoaderSmall";
import CustomerConstants from "../../../common/CustomerConstants";
import { useNavigate } from "react-router-dom";

import customerItemService from "../../../services/customer_appCommonService";
import supplierItemService from "../../../services/supplier_appCommonService";

import toast from "react-hot-toast";
import { formatToTwoDigits } from "../../../common/Validations";

//Redux
import { useSelector } from "react-redux"; //useDispatch

import "./homeIntro.scss";
import AlertNotifications from "../../../Components/AlertNotifications/AlertNotifications";

const HomeIntro = () => {
  const currentDate = new Date();
  localStorage.setItem("menu", "Home");
  localStorage.setItem("submenu", "-");
  const navigate = useNavigate();

  const appConfig = useSelector((state) => state?.app?.appConfig); // Application Details from Store
  let userData = useSelector((state) => state?.user?.data); // User Details from Store

  const navigateToMainPage = (page) => {
    if (page === "totalOrderCount") {
      navigate(CustomerConstants.CUSTOMER_V2_ORDER_BOOKING_LIST_LINE_ITEM);
    } else if (page === "totalMaterilaOrderCount") {
      navigate(CustomerConstants.CUSTOMER_V5_PURCHASE_ORDER_LIST);
    } else if (page === "totalServicePurchaseOrderCount") {
      navigate(
        CustomerConstants.CUSTOMER_V5_MR_POCOLLABRATION_SERVICE_PURCHASE_ORDER_LIST,
      );
    } else if (page === "grnList") {
      navigate(
        CustomerConstants.CUSTOMER_V5_MR_POCOLLABRATION_GOODS_RECEIVED_NOTE,
      );
    } else if (page === "totalSupplierCount") {
      navigate(CustomerConstants.SUPPILER_LIST_MR);
    } else if (page === "orderCompletedCount") {
      navigate(CustomerConstants.CUSTOMER_V1_ORDER_COMPLETE_SCHEDULING_LIST);
    } else if (page === "confirmedDispatchCount") {
      navigate(CustomerConstants.CUSTOMER_V1_DISPATCH_CONFIRMATION_LIST);
    } else if (page === "totalUserCount") {
      navigate(CustomerConstants.CUSTOMER_V2_CUSTOMER_MASTER_LIST);
    } else if (page === "loadingAdvice") {
      navigate(CustomerConstants.CUSTOMER_V2_LOADING_ADVICE_LIST);
    } else if (page === "totalInvoiceCount") {
      navigate(CustomerConstants.CUSTOMER_V2_INVOICE_LIST);
    } else if (page === "ERF") {
      navigate(CustomerConstants.CUSTOMER_V5_MR_ERF_LIST);
    } else if (page === "ERFMAT") {
      navigate(CustomerConstants.CUSTOMER_V5_MR_MATERIAL_LIST);
    }
  };

  const [totalUserCount, setTotalUserCount] = useState("");
  const [totalUserCountStatus, setTotalUserCountStatus] = useState(false);

  const [confirmedDispatchCount, setConfirmedDispatchCount] = useState("");
  const [confirmedDispatchStatus, setConfirmedDispatchStatus] = useState(false);

  const [orderCompletedCount, setOrderCompletedCount] = useState("");
  const [orderPendingCount, setPendingCount] = useState("");
  const [orderCompletedStatus, setOrderCompletedStatus] = useState(false);

  const [totalOrderCount, setTotalOrderCount] = useState("");
  const [totalOrderCountStatus, setTotalOrderStatus] = useState(false);

  const [totalPostDispatchCount, setTotalPostDispatchCount] = useState("");
  // eslint-disable-next-line no-unused-vars
  const [totalPostDispatchCountStatus, setTotalPostDispatchCountStatus] =
    useState(false);

  const [productdata, setProductdata] = useState({});
  const [cards, setCards] = useState({});

  const [totalLoadingAdviceCount, setTotalLoadingAdviceCount] = useState("");
  const [totalLoadingAdviceCountStatus, setTotalLoadingAdviceCountStatus] =
    useState(false);

  const [totalInvoiceCount, setTotalInvoiceCount] = useState("");
  const [totalInvoiceCountStatus, setTotalInvoiceCountStatus] = useState(false);

  // loadOrderCount
  const loadOrderCount = async () => {
    setTotalOrderStatus(true);
    let obj = {
      queryName: "GetTotalOrderCount",
    };

    await customerItemService.ChartCountCard(obj).then((item) => {
      // console.log(">> Details res!", item);
      if (item?.status === 200) {
        setTotalOrderCount(item.data);

        loadOrderCompletedCount(item.data);
      } else {
        toast.error(item?.message || "Please try again for Total PO Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setTotalOrderStatus(false);
  };

  const [totalMaterialOrderCount, setTotalMaterialOrderCount] = useState("");
  const [totalMaterialOrderCountStatus, setTotalMaterialOrderStatus] =
    useState(false);

  // materialorderloadOrderCount
  const materialloadOrderCount = async () => {
    setTotalMaterialOrderStatus(true);

    let obj = {
      module: "PO",
      queryName: "getMaterialPO",
      page: 1,
      per_page: 10,
    };

    await customerItemService.generateQuery(obj).then((item) => {
      if (item?.status === 200) {
        setTotalMaterialOrderCount(item?.total);
      } else {
        toast.error(item?.message || "Please try again for Total PO Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setTotalMaterialOrderStatus(false);
  };
  const [
    getTotalServicesPurchaseOrderStatus,
    setTotalServicesPurchaseOrderStatus,
  ] = useState();
  const [
    getTotalServicesPurchaseOrderCount,
    setTotalServicesPurchaseOrderCount,
  ] = useState();
  // servicesPurchaseOrderCount
  const servicesPurchaseOrderCount = async () => {
    setTotalServicesPurchaseOrderStatus(true);

    let obj = {
      module: "PO",
      queryName: "getServicePO",
      page: 1,
      per_page: 10,
    };

    await customerItemService.generateQuery(obj).then((item) => {
      if (item?.status === 200) {
        setTotalServicesPurchaseOrderCount(item?.total);

        // loadOrderCompletedCount(item.data);
      } else {
        toast.error(item?.message || "Please try again for Total PO Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setTotalServicesPurchaseOrderStatus(false);
  };

  const [getGrnStatus, setGrnStatus] = useState();
  const [getTotalGrnCount, setTotalGrnCount] = useState();
  // GRNCount
  const grnCount = async () => {
    setGrnStatus(true);

    let obj = {
      module: "",
      queryName: "",
      page: 1,
      per_page: 10,
    };

    await supplierItemService.getGoodsReceivedNote(obj).then((item) => {
      if (item?.status === 200) {
        setTotalGrnCount(item?.total);

        // loadOrderCompletedCount(item.data);
      } else {
        toast.error(item?.message || "Please try again for Total PO Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setGrnStatus(false);
  };

  const [totalSupplierCount, setTotalSupplierCount] = useState("");
  const [totalSupplierCountStatus, setTotalSupplierCountStatus] =
    useState(false);

  // load Supplier Count
  const loadSupplierCount = async () => {
    setTotalSupplierCountStatus(true);
    let obj = {
      page: 1,
      per_page: 10,
      queryName: "getSupplier_StatusChartList",
    };

    await supplierItemService.getSupplierList(obj).then((item) => {
      if (item?.status === 200) {
        setTotalSupplierCount(item?.total);
      } else {
        toast.error(
          item?.message || "Please try again for Total Supplier Count",
          {
            duration: 4000,
            position: "top-right",
          },
        );
      }
    });
    setTotalSupplierCountStatus(false);
  };

  const [totalErfCount, setTotalErfCount] = useState("");
  const [totalErfCountStatus, setTotalErfCountStatus] = useState(false);
  // load ERF Count
  const loadErfCount = async () => {
    setTotalErfCountStatus(true);
    let obj = {
      queryName: "ERFList",
      page: 1,
      per_page: 10,
    };

    await customerItemService.generateQuery(obj).then((item) => {
      if (item?.status === 200) {
        setTotalErfCount(item?.total);
      } else {
        toast.error(
          item?.message || "Please try again for Total Supplier Count",
          {
            duration: 4000,
            position: "top-right",
          },
        );
      }
    });
    setTotalErfCountStatus(false);
  };
  const [totalMaterialCount, setTotalMaterialCount] = useState("");
  const [totalMaterialCountStatus, setTotalMaterialCountStatus] =
    useState(false);
  // load ERF Count
  const loadMaterialCount = async () => {
    setTotalMaterialCountStatus(true);
    let obj = {
      queryName: "getMaterilMasterList",
      page: 1,
      per_page: 10,
    };

    await customerItemService.generateQuery(obj).then((item) => {
      if (item?.status === 200) {
        setTotalMaterialCount(item?.total);
      } else {
        toast.error(
          item?.message || "Please try again for Total Supplier Count",
          {
            duration: 4000,
            position: "top-right",
          },
        );
      }
    });
    setTotalMaterialCountStatus(false);
  };
  // loadOrderCompletedCount
  const loadOrderCompletedCount = async (totalOrderCountVal) => {
    setOrderCompletedStatus(true);
    let obj = {
      queryName: "totalOrderCompletedCount",
    };

    await customerItemService.ChartCountCard(obj).then((item) => {
      if (item?.status === 200) {
        setOrderCompletedCount(item.data);
        let orderComplete = item.data;
        setPendingCount(totalOrderCountVal - orderComplete);
      } else {
        toast.error(item?.message || "Please try again for Total PO Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setOrderCompletedStatus(false);
  };

  // loadConfirmedDispatchCount
  const loadConfirmedDispatchCount = async () => {
    setConfirmedDispatchStatus(true);
    let obj = {
      queryName: "totalConfirmedDispatchCount",
    };

    await customerItemService.ChartCountCard(obj).then((item) => {
      // console.log(">> Details res!", item);
      if (item?.status === 200) {
        setConfirmedDispatchCount(item.data);
      } else {
        toast.error(item?.message || "Please try again for Total PO Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setConfirmedDispatchStatus(false);
  };

  // loadCustomerCount
  const loadCustomerCount = async () => {
    setTotalUserCountStatus(true);
    let obj = {
      queryName: "totalCustomerCount",
    };

    await customerItemService.ChartCountCard(obj).then((item) => {
      if (item?.status === 200) {
        setTotalUserCount(item.data);
      } else {
        toast.error(item?.message || "Please try again for Total User Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setTotalUserCountStatus(false);
  };

  const loadPostDispatchCount = async () => {
    setTotalPostDispatchCountStatus(true);
    let obj = {
      queryName: "totalPostDispatchCount",
    };

    await customerItemService.ChartCountCard(obj).then((item) => {
      // console.log(">> Details res!", item);
      if (item?.status === 200) {
        setTotalPostDispatchCount(item.data);
      } else {
        toast.error(item?.message || "Please try again for Total User Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setTotalPostDispatchCountStatus(false);
  };

  // loading Advice
  // const loadingAdviceCount = async () => {
  //   setTotalLoadingAdviceCountStatus(true);
  //   let obj = {
  //     queryName: "totalLoadingAdviceCount",
  //   };

  //   await customerItemService.ChartCountCard(obj).then((item) => {
  //     // console.log(">> Details res!", item);
  //     if (item?.status === 200) {
  //       setTotalLoadingAdviceCount(item.data);
  //     } else {
  //       toast.error(item?.message || "Please try again for Total User Count", {
  //         duration: 4000,
  //         position: "top-right",
  //       });
  //     }
  //   });
  //   setTotalLoadingAdviceCountStatus(false);
  // };

  const loadingAdviceCount = async () => {
    try {
      setTotalLoadingAdviceCountStatus(true);

      const obj = {
        queryName: "getLoadingAdviceList",
      };

      const item = await customerItemService.generateCustomerQuery(obj);

      if (item?.status === 200) {
        setTotalLoadingAdviceCount(item?.total || 0);
      } else {
        toast.error(
          item?.message || "Please try again for Total Loading Advice Count",
          {
            duration: 4000,
            position: "top-right",
          },
        );
      }
    } catch (error) {
      console.error("Loading Advice Count Error:", error);
      setTotalLoadingAdviceCount(0);
    } finally {
      setTotalLoadingAdviceCountStatus(false);
    }
  };

  // loadInvoice
  // const loadInvoiceCount = async () => {
  //   setTotalInvoiceCountStatus(true);
  //   let obj = {
  //     queryName: "Company_And_Customer_Ledger",
  //     rowFilter: {
  //       $and: [
  //         {
  //           transactionType: "INV",
  //         },
  //       ],
  //     },
  //     page: 1,
  //     per_page: 10,
  //   };

  //   await customerItemService.generateCustomerQuery(obj).then((item) => {
  //     // console.log(">> Details res!", item);
  //     if (item?.status === 200) {
  //       setTotalInvoiceCount(item?.total ?? 0);
  //     } else {
  //       toast.error(item?.message || "Please try again for Total User Count", {
  //         duration: 4000,
  //         position: "top-right",
  //       });
  //     }
  //   });
  //   // let obj = {
  //   //   queryName: "totalInvoiceCount",
  //   // };

  //   // await customerItemService.ChartCountCard(obj).then((item) => {
  //   //   // console.log(">> Details res!", item);
  //   //   if (item?.status === 200) {
  //   //     setTotalInvoiceCount(item.data);
  //   //   } else {
  //   //     toast.error(item?.message || "Please try again for Total User Count", {
  //   //       duration: 4000,
  //   //       position: "top-right",
  //   //     });
  //   //   }
  //   // });
  //   setTotalInvoiceCountStatus(false);
  // };

    const loadInvoiceCount = async () => {
      try {
        setTotalInvoiceCountStatus(true);
  
        const obj = {
          queryName: "getCustomerInvoiceList",
          page: 1,
          per_page: 10,
        };
  
        const item = await customerItemService.generateCustomerQuery(obj);
  
        if (item?.status === 200) {
          setTotalInvoiceCount(item?.total ?? 0);
        } else {
          toast.error(
            item?.message || "Please try again for Total Invoice Count",
            {
              duration: 4000,
              position: "top-right",
            },
          );
        }
      } catch (error) {
        console.error("Invoice Count Error:", error);
        setTotalInvoiceCount(0);
      } finally {
        setTotalInvoiceCountStatus(false);
      }
    };

  useEffect(() => {
    loadOrderCount();
    loadPostDispatchCount();
    loadConfirmedDispatchCount();
    loadCustomerCount();

    loadingAdviceCount();
    loadInvoiceCount();

    materialloadOrderCount();
    servicesPurchaseOrderCount();
    grnCount();
    loadSupplierCount();
    loadErfCount();
    loadMaterialCount();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setProductdata(appConfig?.homeIntro);
    setCards(appConfig?.homeIntro?.cards);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appConfig]);

  // Format the date (optional)
  const formattedDate = currentDate.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  // const [getIntroVideo, setIntroVideo] = useState(false);
  const [getCategoryDetail, setCategoryDetail] = useState(false);
  const [hideItem, setHideItem] = useState(false);

  // eslint-disable-next-line no-unused-vars
  const categoryDetailShow = () => {
    // setCategoryDetail(true);
  };

  const categoryDetailHide = () => {
    setCategoryDetail(false);
  };

  useEffect(() => {
    const userRole = userData?.roles?.[0]?.roleId || null;

    if (userRole === "CUSTOMER") {
      setHideItem(true);
    } else {
      setHideItem(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData]);

  const ProductSection = ({ data }) => {
    return (
      <Row className="homeintroposter">
        {/* Product Info Section */}
        <Col
          xs={12}
          md={12}
          lg={12}
          className="postertext d-flex justify-content-center align-items-center flex-column mb-4"
        >
          <p className="fw-bold ms-2 fs-3">{data?.mainTitle}</p>
          <div className="smarthub">
            <p className="fs-5 fw-bold ms-2">{data?.subTitle}</p>
          </div>
        </Col>
        {/* Loop through products */}

        {data?.products?.map((product, index) => (
          <Col
            key={index}
            xs={12}
            md={2}
            lg={2}
            className="d-flex flex-column align-items-center p-2"
          >
            <div className="image-box d-flex justify-content-center align-items-center">
              <img
                className="img-fluid"
                src={product?.image}
                alt={product?.alt}
              />
            </div>
            <p className="fs-5 fw-bold m-0">{product?.name}</p>
          </Col>
        ))}
      </Row>
    );
  };
  //role selection
  const [userRoleData, serUserRoleData] = useState();
  useEffect(() => {
    if (userData?.roles) {
      const allowedRoles = ["SALES-ADMIN", "SALES-OFFICER"];
      const isAllowed = userData.roles.some((r) =>
        allowedRoles.includes(r.roleId),
      );
      serUserRoleData(isAllowed);
    }
  }, [userData]);
  return (
    <main className="dashboard main customer" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row className="home-intro">
              <Col xs={12} md={12} lg={12} className="headers p-2 mb-2">
                <Row>
                  <Col xs={12} md={2} lg={2}>
                    <div className="welcome">
                      <p>Welcome to</p>
                      <span>Customer Portal</span>
                    </div>
                  </Col>
                  <Col
                    xs={12}
                    md={8}
                    lg={8}
                    className="d-flex justify-content-center"
                  >
                    <div className="d-flex justify-content-start align-times-end">
                      {appConfig?.customerLogo1 && (
                        <img
                          className="img-fluid introCustomerlogo"
                          src={appConfig?.customerLogo1}
                          alt="logo1"
                        />
                      )}
                      <p className="fw-bold ms-2 fs-2">
                        {appConfig?.customerName}
                      </p>
                      {appConfig?.customerLogo2 && (
                        <img
                          className="img-fluid"
                          src={appConfig?.customerLogo2}
                          alt="logo2"
                        />
                      )}
                    </div>
                  </Col>
                  <Col xs={12} md={2} lg={2}>
                    <div className="date commTopButtonRightLeftPadding">
                      {/* <p>Today Date:</p> */}
                      <InputField
                        className="inputBox"
                        label=""
                        name="Fuels"
                        id="Fuels"
                        placeholder=""
                        // type="date"
                        value={formattedDate}
                        // onChange={onInputChange}
                        disabled={true}
                      />
                    </div>
                  </Col>
                </Row>
              </Col>

              <Col xs={12} md={12} lg={12} className="card mb-2">
                {/* <p className="title p-2 mb-0">Overview</p> */}

                <div className="row">
                  {userRoleData && cards?.materialPurchaseOrders && (
                    <>
                      {/* Material Purchase Orders */}
                      <div className="col-lg-3 commTopButtonRightLeftPadding">
                        <div className="card info-card sales-card">
                          <div className="card-body">
                            <h5 className="card-title">
                              Material Purchase Orders
                            </h5>

                            <div className="d-flex align-items-center">
                              <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                                <i class="bi bi-box-seam"></i>
                              </div>
                              <div className="ps-3">
                                <LoaderSmall
                                  isLoading={totalMaterialOrderCountStatus}
                                />
                                <h6>
                                  {!totalMaterialOrderCountStatus
                                    ? formatToTwoDigits(
                                        totalMaterialOrderCount || 0,
                                      )
                                    : ""}
                                </h6>
                                <span className="text-muted small pt-2 ps-1">
                                  Total Count
                                </span>
                                <span
                                  className="text-muted small pt-2 ps-1"
                                  onClick={() =>
                                    navigateToMainPage(
                                      "totalMaterilaOrderCount",
                                    )
                                  }
                                >
                                  <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                  {userRoleData && cards?.servicePurchaseOrders && (
                    <>
                      {/* Material Purchase Orders */}
                      <div className="col-lg-3 commTopButtonRightLeftPadding">
                        <div className="card info-card sales-card">
                          <div className="card-body">
                            <h5 className="card-title">
                              Service Purchase Orders
                              {/* <span>| Today</span> */}
                            </h5>

                            <div className="d-flex align-items-center">
                              <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                                <i class="bi bi-tools"></i>
                              </div>
                              <div className="ps-3">
                                <LoaderSmall
                                  isLoading={
                                    getTotalServicesPurchaseOrderStatus
                                  }
                                />
                                <h6>
                                  {!getTotalServicesPurchaseOrderStatus
                                    ? formatToTwoDigits(
                                        getTotalServicesPurchaseOrderCount || 0,
                                      )
                                    : ""}
                                </h6>
                                <span className="text-muted small pt-2 ps-1">
                                  Total Count
                                </span>
                                <span
                                  className="text-muted small pt-2 ps-1"
                                  onClick={() =>
                                    navigateToMainPage(
                                      "totalServicePurchaseOrderCount",
                                    )
                                  }
                                >
                                  <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                  {userRoleData && cards?.goodsReceipt && (
                    <>
                      {/* Material Purchase Orders */}
                      <div className="col-lg-3 commTopButtonRightLeftPadding">
                        <div className="card info-card customers-card">
                          <div className="card-body">
                            <h5 className="card-title">Goods Receipt</h5>

                            <div className="d-flex align-items-center">
                              <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                                <i className="bi bi-truck"></i>{" "}
                              </div>
                              <div className="ps-3">
                                <LoaderSmall isLoading={getGrnStatus} />
                                <h6>
                                  {!getGrnStatus
                                    ? formatToTwoDigits(getTotalGrnCount || 0)
                                    : ""}
                                </h6>

                                <span className="text-muted small pt-2 ps-1">
                                  Total Count
                                </span>
                                <span
                                  className="text-muted small pt-2 ps-1"
                                  onClick={() => navigateToMainPage("grnList")}
                                >
                                  <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                  {userRoleData && cards?.supplier && (
                    <>
                      {/*supplier or vendor */}
                      <div className="col-lg-3 commTopButtonRightLeftPadding">
                        <div className="card info-card customers-card">
                          <div className="card-body">
                            <h5 className="card-title">
                              Supplier/Vendor
                              {/* <span>| This Year</span> */}
                            </h5>

                            <div className="d-flex align-items-center">
                              <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                                <i className="bi bi-people"></i>
                              </div>
                              <div className="ps-3">
                                <LoaderSmall
                                  isLoading={totalSupplierCountStatus}
                                />
                                <h6>
                                  {!totalSupplierCountStatus
                                    ? formatToTwoDigits(totalSupplierCount || 0)
                                    : ""}
                                </h6>
                                <span className="text-muted small pt-2 ps-1">
                                  Total Count
                                </span>
                                <span
                                  className="text-muted small pt-2 ps-1"
                                  onClick={() =>
                                    navigateToMainPage("totalSupplierCount")
                                  }
                                >
                                  <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                  {userRoleData && cards?.eRF && (
                    <>
                      {/*supplier or vendor */}
                      <div className="col-lg-3 commTopButtonRightLeftPadding">
                        <div className="card info-card customers-card">
                          <div className="card-body">
                            <h5 className="card-title">
                              ERF
                              {/* <span>| This Year</span> */}
                            </h5>

                            <div className="d-flex align-items-center">
                              <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                                <i className="bi bi-people"></i>
                              </div>
                              <div className="ps-3">
                                <LoaderSmall isLoading={totalErfCountStatus} />
                                <h6>
                                  {!totalErfCountStatus
                                    ? formatToTwoDigits(totalErfCount || 0)
                                    : ""}
                                </h6>
                                <span className="text-muted small pt-2 ps-1">
                                  Total Count
                                </span>
                                <span
                                  className="text-muted small pt-2 ps-1"
                                  onClick={() => navigateToMainPage("ERF")}
                                >
                                  <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                  {userRoleData && cards?.material && (
                    <>
                      {/*supplier or vendor */}
                      <div className="col-lg-3 commTopButtonRightLeftPadding">
                        <div className="card info-card customers-card">
                          <div className="card-body">
                            <h5 className="card-title">
                              Material
                              {/* <span>| This Year</span> */}
                            </h5>

                            <div className="d-flex align-items-center">
                              <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                                <i className="bi bi-people"></i>
                              </div>
                              <div className="ps-3">
                                <LoaderSmall
                                  isLoading={totalMaterialCountStatus}
                                />
                                <h6>
                                  {!totalMaterialCountStatus
                                    ? formatToTwoDigits(totalMaterialCount || 0)
                                    : ""}
                                </h6>
                                <span className="text-muted small pt-2 ps-1">
                                  Total Count
                                </span>
                                <span
                                  className="text-muted small pt-2 ps-1"
                                  onClick={() => navigateToMainPage("ERFMAT")}
                                >
                                  <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                  {userRoleData && cards?.orders && (
                    <>
                      {/* orders */}
                      <div className="col-lg-3 commTopButtonRightLeftPadding">
                        <div className="card info-card sales-card">
                          <div className="card-body">
                            <h5 className="card-title">
                              Orders
                              {/* <span>| Today</span> */}
                            </h5>

                            <div className="d-flex align-items-center">
                              <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                                <i className="bi bi-boxes"></i>
                              </div>
                              <div className="ps-3">
                                <LoaderSmall
                                  isLoading={totalOrderCountStatus}
                                />
                                <h6>
                                  {!totalOrderCountStatus
                                    ? formatToTwoDigits(totalOrderCount || 0)
                                    : ""}
                                </h6>
                                {/* <span className="text-success small pt-1 fw-bold">
                            12%
                          </span>{" "} */}
                                <span className="text-muted small pt-2 ps-1">
                                  Total Count
                                </span>
                                <span
                                  className="text-muted small pt-2 ps-1"
                                  onClick={() =>
                                    navigateToMainPage("totalOrderCount")
                                  }
                                >
                                  <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}

                  {cards?.completed && (
                    <>
                      {/* completed */}
                      <div className="col-lg-3 commTopButtonRightLeftPadding">
                        <div className="card info-card revenue-card">
                          <div className="card-body">
                            <h5 className="card-title">
                              Completed / Pending
                              {/* <span>| This Month</span> */}
                            </h5>

                            <div className="d-flex align-items-center">
                              <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                                <i className="bi bi-box-seam"></i>
                              </div>
                              <div className="ps-3">
                                <LoaderSmall isLoading={orderCompletedStatus} />
                                <h6>
                                  {!orderCompletedStatus
                                    ? formatToTwoDigits(
                                        orderCompletedCount || 0,
                                      ) +
                                      " / " +
                                      formatToTwoDigits(orderPendingCount || 0)
                                    : ""}
                                </h6>
                                {/* <span className="text-success small pt-1 fw-bold">
                            12%
                          </span>{" "} */}
                                <span className="text-muted small pt-2 ps-1">
                                  Order Counts
                                </span>
                                <span
                                  className="text-muted small pt-2 ps-1"
                                  onClick={() =>
                                    navigateToMainPage("orderCompletedCount")
                                  }
                                >
                                  <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}

                  {cards?.dispatch && (
                    <>
                      {/* Dispatch */}
                      <div className="col-lg-3 commTopButtonRightLeftPadding">
                        <div className="card info-card customers-card">
                          <div className="card-body">
                            <h5 className="card-title">
                              Dispatch / Confimed
                              {/* <span>| This Year</span> */}
                            </h5>

                            <div className="d-flex align-items-center">
                              <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                                <i className="bi bi-truck"></i>
                              </div>
                              <div className="ps-3">
                                <LoaderSmall
                                  isLoading={confirmedDispatchStatus}
                                />
                                <h6>
                                  {!confirmedDispatchStatus
                                    ? formatToTwoDigits(
                                        totalPostDispatchCount || 0,
                                      ) +
                                      " / " +
                                      formatToTwoDigits(
                                        confirmedDispatchCount || 0,
                                      )
                                    : ""}
                                </h6>
                                <span className="text-muted small pt-2 ps-1">
                                  Count
                                </span>
                                <span
                                  className="text-muted small pt-2 ps-1"
                                  onClick={() =>
                                    navigateToMainPage("confirmedDispatchCount")
                                  }
                                >
                                  <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                  {userRoleData && cards?.loading && (
                    <>
                      {/* Loading */}
                      <div className="col-lg-3 commTopButtonRightLeftPadding">
                        <div className="card info-card customers-card">
                          <div className="card-body">
                            <h5 className="card-title">Loading</h5>

                            <div className="d-flex align-items-center">
                              <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                                <i className="bi bi-truck"></i>{" "}
                              </div>
                              <div className="ps-3">
                                <LoaderSmall
                                  isLoading={totalLoadingAdviceCountStatus}
                                />
                                <h6>
                                  {!totalLoadingAdviceCountStatus
                                    ? formatToTwoDigits(
                                        totalLoadingAdviceCount || 0,
                                      )
                                    : ""}
                                </h6>

                                <span className="text-muted small pt-2 ps-1">
                                  Total Count
                                </span>
                                <span
                                  className="text-muted small pt-2 ps-1"
                                  onClick={() =>
                                    navigateToMainPage("loadingAdvice")
                                  }
                                >
                                  <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}

                  {userRoleData && cards?.invoice && (
                    <>
                      {/* Invoice */}
                      <div className="col-lg-3 commTopButtonRightLeftPadding">
                        <div className="card info-card revenue-card">
                          <div className="card-body">
                            <h5 className="card-title">Invoice</h5>

                            <div className="d-flex align-items-center">
                              <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                                <i className="bi bi-file-text"></i>
                              </div>
                              <div className="ps-3">
                                <LoaderSmall
                                  isLoading={totalInvoiceCountStatus}
                                />
                                <h6>
                                  {!totalInvoiceCountStatus
                                    ? formatToTwoDigits(totalInvoiceCount || 0)
                                    : ""}
                                </h6>
                                {/* <span className="text-success small pt-1 fw-bold">
                                            12%
                                          </span>{" "} */}
                                <span className="text-muted small pt-2 ps-1">
                                  Total Count
                                </span>
                                <span
                                  className="text-muted small pt-2 ps-1"
                                  onClick={() =>
                                    navigateToMainPage("totalInvoiceCount")
                                  }
                                >
                                  <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                  {userRoleData && cards?.customers && (
                    <>
                      {/* Customers */}
                      {!hideItem && (
                        <div className="col-lg-3 commTopButtonRightLeftPadding">
                          <div className="card info-card customers-card">
                            <div className="card-body">
                              <h5 className="card-title">
                                Customers
                                {/* <span>| This Year</span> */}
                              </h5>

                              <div className="d-flex align-items-center">
                                <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                                  <i className="bi bi-people"></i>
                                </div>
                                <div className="ps-3">
                                  <LoaderSmall
                                    isLoading={totalUserCountStatus}
                                  />
                                  <h6>
                                    {!totalUserCountStatus
                                      ? formatToTwoDigits(totalUserCount || 0)
                                      : ""}
                                  </h6>
                                  <span className="text-muted small pt-2 ps-1">
                                    Total Count
                                  </span>
                                  <span
                                    className="text-muted small pt-2 ps-1"
                                    onClick={() =>
                                      navigateToMainPage("totalUserCount")
                                    }
                                  >
                                    <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </>
                  )}
                </div>
              </Col>

              {/* Scrolling Message */}
              <Row className="homeintroposter my-2">
                <Col xs={12} md={12} lg={12}>
                  {appConfig?.scrollingTextInHomePage?.enabled === true && (
                    <>
                      <AlertNotifications
                        message={
                          appConfig?.scrollingTextInHomePage?.displayMessage
                        }
                      />
                    </>
                  )}
                </Col>
              </Row>
              {/* Scrolling message end */}

              <Col xs={12} md={12} lg={12} className="mb-2">
                <ProductSection data={productdata} />
              </Col>
            </Row>
          </div>
        </Col>
      </Row>

      {/* <HomeIntorVideo show={getIntroVideo} onHide={introVideoHide} videopath={getVideoPath} /> */}
      <HomeCategorieDetails
        show={getCategoryDetail}
        onHide={categoryDetailHide}
      />
    </main>
  );
};
export default HomeIntro;
